define('editor/edit/map/controls/tile-layer-switch',['leaflet-tilelayer-switch'], function () { 
    var control = function (options) {
        var self = this;

        self.options = options;

        self.addToMap = function () {
            self.control = L.control.tileLayerSwitch({
                tileLayers: self.options.tileLayers  
            });

            self.control.addTo(self.options.mapControl);
        };
    };

    return control;
});

